export function useSearchRedirect(redirect: string) {
  const redirectBaseUrl = new URL(redirect as string)
  const baseUrlHost = useRequestHeaders().host ?? location.host
  if (baseUrlHost === redirectBaseUrl.host) {
    navigateTo(redirectBaseUrl.pathname + redirectBaseUrl.search)
  }
  else {
    navigateTo(redirect, {
      external: true,
    })
  }
}
